export const meta: BlockMeta = {
  title: "Project List",
  tags: ["#page"],
}

import { Button } from "@components/atoms/Button"
import { ResponsiveImage } from "@components/atoms/ResponsiveImage"
import { Appear } from "@components/motion/Appear"
import { defineBlock, EditableText } from "eddev/blocks"
import { Link } from "eddev/routing"

export default defineBlock("content/project-list", (props) => {
  const projects = (props.projects || props.allProjects?.nodes || []).filter((p) => !p?.projectHeader?.unlisted)

  return (
    <div className="content-sized block-spacing relative flex flex-col gap-8 md:gap-6">
      <EditableText
        as="h3"
        store="title"
        className="type-desktop-headings-heading-xs leading-none border-b border-b-concrete pb-8 md:pb-6"
        placeholder="Featured projects"
        defaultValue="Featured projects"
      />
      {projects.map(
        (project, index) =>
          project?.uri && (
            <Appear
              key={index}
              className="w-full flex flex-col-reverse md:flex-row items-start md:justify-between gap-8 md:gap-6 md:border-b md:border-b-concrete pb-4 md:pb-6"
            >
              <div className="md:w-full flex flex-row items-center md:items-start md:flex-col self-stretch justify-between type-mobile-headings-heading-s md:type-desktop-headings-heading-l">
                <Link href={project.uri} className="flex flex-col gap-0">
                  <p>{project.title}</p>
                  <p className="text-concrete">{project.projectHeader?.location?.[0]?.name}</p>
                </Link>
                <Button href={project.uri} className="!hidden md:!flex">
                  View Project
                </Button>
                <Link href={project.uri} className="md:hidden">
                  <svg className="w-7 h-7" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4 12H18M13 17L18 12L13 7" stroke="black" />
                  </svg>
                </Link>
              </div>
              <Link href={project.uri} className="w-full md:w-auto flex flex-nowrap gap-4">
                {project.projectHeader?.featuredImage?.mediaItemUrl && (
                  <ResponsiveImage
                    {...project.projectHeader.featuredImage}
                    className="w-full h-auto md:w-auto md:h-projectListImgH"
                  />
                )}
              </Link>
            </Appear>
          ),
      )}
    </div>
  )
})
